import { ReactComponent as FillDownArrowSvg } from "./down-arrow_2.svg";
const FillDownArrowIcon = (props) => {
  return <FillDownArrowSvg {...props} />;
};
export default FillDownArrowIcon;
